import React from "react";
import SelectFilter from "../selectFilter";
import { DECLARANT_CERT_STATUSES } from "../../../../../constants/values";
import { IFilterProps } from "../Interfaces";

const CertStatusFilter: React.FC<IFilterProps> = ({
  setSelectedKeys,
  confirm,
  clearFilters,
  selectedKeys,
  multiple,
}) => (
  <SelectFilter
    setSelectedKeys={setSelectedKeys}
    confirm={confirm}
    clearFilters={clearFilters}
    options={DECLARANT_CERT_STATUSES}
    selectedKeys={selectedKeys}
    multiple={multiple}
  />
);

export default CertStatusFilter;
